import React from "react";
import { FormGroup, ControlLabel, FormControl } from "react-bootstrap";
import FieldSettings from "./Event/FieldSettings";

function addressIsEmpty(address) {
  return (
    !address.line1 &&
    !address.line2 &&
    !address.city &&
    !address.state &&
    !address.zip
  );
}

const Address = (props) => {
  const { address, multiline, styles } = props;
  if (!address || addressIsEmpty(address)) {
    return null;
  } else {
    const separator = multiline ? <br /> : " ";
    return (
      <FormGroup className={styles.dataValuePair}>
        <ControlLabel className={styles.dataValuePairLabel}>
          Location
        </ControlLabel>
        <FormControl.Static
          className={styles.dataValuePairValue}
          componentClass={"div"}
        >
          <FieldSettings.Consumer>
            {(fields) => {
              if (fields) {
                const addressFields = fields.location.fields;
                const line1 = addressFields.line1.visible ? address.line1 : "";
                const line2 = addressFields.line2.visible ? address.line2 : "";
                const city = addressFields.city.visible ? address.city : "";
                const state = addressFields.state.visible ? address.state : "";
                const zip = addressFields.zip.visible ? address.zip : "";
                return (
                  <address {...props}>
                    {line1}
                    {!!line1 && separator}
                    {line2}
                    {!!line2 && separator}
                    {`${city || ""}${city && state ? "," : ""} ${state || ""} ${
                      zip || ""
                    }`}
                  </address>
                );
              } else {
                return (
                  <address {...props}>
                    {address.line1}
                    {!!address.line1 && separator}
                    {address.line2}
                    {!!address.line2 && separator}
                    {`${address.city || ""}${
                      address.city && address.state ? "," : ""
                    } ${address.state || ""} ${address.zip || ""}`}
                  </address>
                );
              }
            }}
          </FieldSettings.Consumer>
        </FormControl.Static>
      </FormGroup>
    );
  }
};

export default Address;
